/**
 * The words the closed and transient stages show. Pinned in one place so
 * a Playwright test can assert the exact string (Task 12's own
 * verification line: "a Playwright test pins... that the 'put away' copy
 * matches the design's line exactly") and so the two states can never
 * accidentally converge on the same sentence — that convergence is
 * exactly the "small dishonesty" the plan calls out.
 */

/** A definitive denial — revoked, epoch-killed, or never existed. The
 *  plan's own words, verbatim. */
export const CLOSED_COPY = 'this venn was put away';

/** A resolve/read attempt that has not yet succeeded OR definitively
 *  failed — still retrying with the same in-memory secret. Deliberately
 *  provisional in tone, never claiming the link is dead. */
export const TRANSIENT_COPY = 'still finding its way to you…';

/** Shown once the fetch has exhausted its retry budget (retry.ts) without
 *  ever reaching a definitive server answer — still not "dead" (no
 *  server ever actually said so), but the passive retrying gives way to
 *  a tap the visitor controls. */
export const TRANSIENT_EXHAUSTED_COPY =
  'having trouble reaching it — tap to try again';
